// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"936193f9","153":"c093f02e","349":"63c5a56c","408":"2dd5a35e","535":"091e6e05","570":"84fc48a0","633":"f26c32d3","662":"30bb2417","708":"09ff741d","727":"05231504","731":"4dba1050","868":"034aed17","880":"262bf625","885":"3ed850cf","968":"141848b2","986":"83713c3c"}[chunkId] + ".chunk.js";
};